import { COLORS } from "../../shared/constants";
import { useState } from "react";
import * as api from "../../api";

export default // ─── Clinic Info Tab ──────────────────────────────
function ClinicInfoTab({ info, onSave }) {
  const [form, setForm] = useState({ ...info });
  const [saved, setSaved] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoMsg, setLogoMsg] = useState(null);
  const h = (f, v) => { setForm((p) => ({ ...p, [f]: v })); setSaved(false); };
  const inp = (field, label, placeholder) => (
    <div key={field}>
      <label style={{ fontSize: "12px", fontWeight: "600", color: COLORS.textSecondary, marginBottom: "4px", display: "block" }}>{label}</label>
      <input style={{ width: "100%", height: "40px", padding: "0 12px", borderRadius: "8px", border: `1px solid ${COLORS.border}`, background: COLORS.inputBg, fontSize: "14px", color: COLORS.text, outline: "none", boxSizing: "border-box" }}
        value={form[field] || ""} onChange={(e) => h(field, e.target.value)} placeholder={placeholder} />
    </div>
  );

  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLogoMsg(null);
    try {
      await api.uploadLogo(file);
      setLogoPreview(api.getLogoUrl() + "?t=" + Date.now());
      setLogoMsg({ type: "success", text: "Logo uploaded successfully." });
    } catch (err) {
      setLogoMsg({ type: "error", text: err.error || "Logo upload failed." });
    }
  };

  const handleLogoDelete = async () => {
    setLogoMsg(null);
    try {
      await api.deleteLogo();
      setLogoPreview(null);
      setLogoMsg({ type: "success", text: "Logo removed." });
    } catch (err) {
      setLogoMsg({ type: "error", text: err.error || "Failed to remove logo." });
    }
  };

  return (
    <div>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: COLORS.text, marginBottom: "16px" }}>Clinic Information</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
        {inp("clinic_name", "Clinic Name", "Fox TMS Clinic")}
        {inp("phone", "Phone", "(xxx) xxx-xxxx")}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
        {inp("address_line1", "Address Line 1", "Street address")}
        {inp("address_line2", "Address Line 2", "Suite, unit")}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "12px", marginBottom: "12px" }}>
        {inp("city", "City", "City")}
        {inp("state", "State", "SC")}
        {inp("zip", "ZIP", "29483")}
      </div>
      {inp("email", "Email", "info@clinic.com")}

      {/* Logo Upload */}
      <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: `1px solid ${COLORS.borderLight}` }}>
        <label style={{ fontSize: "12px", fontWeight: "600", color: COLORS.textSecondary, marginBottom: "8px", display: "block" }}>Clinic Logo (for report letterhead)</label>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          {(logoPreview || info.logo_path) && (
            <img
              src={logoPreview || api.getLogoUrl()}
              alt="Clinic logo"
              style={{ width: "52px", height: "52px", objectFit: "contain", borderRadius: "8px", border: `1px solid ${COLORS.border}` }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          )}
          <label style={{ height: "36px", padding: "0 14px", borderRadius: "8px", border: `1px solid ${COLORS.border}`, background: COLORS.surface, color: COLORS.primary, fontSize: "12px", fontWeight: "600", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "5px" }}>
            📷 Upload Logo
            <input type="file" accept="image/png,image/jpeg,image/gif,image/webp" onChange={handleLogoUpload} style={{ display: "none" }} />
          </label>
          {(logoPreview || info.logo_path) && (
            <button onClick={handleLogoDelete}
              style={{ height: "36px", padding: "0 14px", borderRadius: "8px", border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerLight, color: COLORS.danger, fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>
              Remove
            </button>
          )}
        </div>
        {logoMsg && (
          <div style={{ marginTop: "6px", fontSize: "12px", color: logoMsg.type === "success" ? COLORS.accent : COLORS.danger }}>
            {logoMsg.text}
          </div>
        )}
      </div>

      <div style={{ marginTop: "16px", display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={() => { onSave(form); setSaved(true); }}
          style={{ height: "40px", padding: "0 20px", borderRadius: "8px", border: "none", background: COLORS.primary, color: "#FFF", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
          Save Clinic Info
        </button>
        {saved && <span style={{ fontSize: "13px", color: COLORS.accent, fontWeight: "500" }}>✓ Saved</span>}
      </div>
    </div>
  );
}

// ─── Users Tab ────────────────────────────────────

